(function () {
  function getQuantityInput() {
    return (
      document.querySelector('.js-quantity-input') ||
      document.querySelector('input[name="quantity"]')
    );
  }

  function getQuantity(input) {
    var qty = parseInt(input.value, 10);
    return isNaN(qty) ? 0 : qty;
  }

  function getTierRows() {
    return Array.from(
      document.querySelectorAll('[data-tier-pricing] [data-tier-row]')
    );
  }

  function updateActiveTier() {
    var input = getQuantityInput();
    if (!input) return;

    var qty = getQuantity(input);
    var rows = getTierRows();

    rows.forEach(function (row) {
      var min = parseInt(row.getAttribute('data-tier-min'), 10);
      var maxAttr = row.getAttribute('data-tier-max');
      var max = maxAttr ? parseInt(maxAttr, 10) : null;

      var isActive =
        qty >= min &&
        (max === null || qty <= max);

      row.classList.toggle('is-active', isActive);
    });
  }

  function setQuantity(input, quantity) {
    input.value = quantity;

    input.dispatchEvent(
      new Event('input', { bubbles: true })
    );

    input.dispatchEvent(
      new Event('change', { bubbles: true })
    );
  }

  function initTierPricing() {
    var input = getQuantityInput();
    if (!input) return;

    updateActiveTier();

    document.addEventListener('input', function (event) {
      if (event.target === input) {
        updateActiveTier();
      }
    });

    document.addEventListener('change', function (event) {
      if (event.target === input) {
        updateActiveTier();
      }
    });

    document.addEventListener('click', function (event) {
      var row = event.target.closest('[data-tier-row]');
      if (!row) return;

      var min = parseInt(
        row.getAttribute('data-tier-min'),
        10
      );

      if (isNaN(min)) return;

      setQuantity(input, min);
      updateActiveTier();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      initTierPricing
    );
  } else {
    initTierPricing();
  }
})();